import './LoadingCell.scss'

interface LoadingCellProps {
  color?: string
}

export function LoadingCell(props: LoadingCellProps) {
  return (
    <div className="grid-icon-cell">
      <i style={{color: props.color}} className='custom-loader'/>
    </div>
  )
}
